import React from "react";
import { imgPath } from "../../feature/core";

export default function Img({ fileName, fileType = "png", ...props }) {
    return (
        <img
            src={`${imgPath}/${fileName}.${fileType}`}
            srcSet={`${imgPath}/${fileName}@2x.${fileType} 2x`}
            {...props}
        ></img>
    );
}
